<div class="container mt-5" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'" style="page-break-inside:avoid">
  <div class="row my-3">
    <div class="col-sm-12 text-right"><em>IT-10B (2023)</em></div>
  </div>
  <div class="row my-3">
    <div class="col-sm-12 text-center font-weight-bold">
      <h6><strong>Statement of Assets, Liabilities and Expenses (as on <u>30/6/{{assessmentYearStart}}</u>)</strong></h6>
    </div>
  </div>
  <div *ngIf="!returnData?.profileData?.mandatoryITTenB" class="row my-3">
    <div class="col-sm-12 text-center font-weight-bold font-italic">
      <!-- পরিসম্পদ দায় ও ব্যয় বিবরণী উক্ত করদাতার জন্য প্রযোজ্য নয় -->
    </div>
  </div>
  <div class="my-3" style="border: 2px solid black">
    <div class="font-weight-bold text-center">To Whom It May Concern</div>
    <ul>
      <li>All Public Servants.</li>
      <li>If the amount of Total Asset at home and abroad exceeds Taka 50,00,000</li>
      <li>The amount of Total Asset does not exceed Tk. 50,00,000 but owns a Motor Car in any time or Invested in any
        House Popery or Apartment within the City Corporation area or Owns Assets outside Bangladesh or being a
        Shareholder Director of a Company.</li>
      <li>Every Non-Bangladeshi and Non-Resident Bangladesh Natural Person shall submit the statement only in respect of
        Assets Located in Bangladesh.</li>
    </ul>
  </div>
  <div class="row my-5">
    <div class="col-sm-5"><strong>Name of the Taxpayer:</strong> {{returnData?.profileData?.assesName}}</div>
    <div class="col-sm-7 text-right font-weight-bold">
      TIN
      <span class="ml-3" style="white-space: nowrap;">
        <input value="{{item }}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default"
          disabled />
      </span>
    </div>
  </div>

  <!-- <div class="col-sm-12 living-expense-table">
    <div class="row bt bb bl">
      <div class="col-sm-8 br">1. Sources of Fund:</div>
      <div class="col-sm-2 text-center br">Amount (Tk.)</div>
      <div class="col-sm-2 text-center br">Amount (Tk)</div>
    </div>
    <div class="row bt bb bl">
      <div class="col-sm-8 pl-5 br">(a) Total Income Shown in Return (Sl. No. 11 of Statement of Total Income)
      </div>
      <div class="col-sm-2 br"></div>
      <div class="col-sm-2 br"></div>
    </div>
    <div class="row bb bl br">
      <div class="col-sm-8 pl-5 br">(b) Tax Exempted Income (Pls see Instruction Page)
      </div>
      <div class="col-sm-2 br"></div>
      <div class="col-sm-2 br"></div>
    </div>
  </div> -->


  <div class="row mx-2">
    <div class="col-sm-12 resLbReturnViewTable">
      <div class="row">
        <div class="col-sm-12">
          <div class="row bt bb bl">
            <div class="col-sm-8 br">
              1. Sources of Fund:
            </div>
            <div class="col-sm-2 br text-center">Amount (Tk.)</div>
            <div class="col-sm-2 br text-center">Amount (Tk)</div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 30px;">
              (a) Total Income Shown in Return (Sl. No. 11 of Statement of Total Income)
            </div>
            <div class="col-sm-2 br text-right pr-3">
              <span>{{restructuredData?.sources_of_fund?.income_shown_in_the_return?.value | currencySeparatorBD}}</span>
            </div>
            <div class="col-sm-2 br"></div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 30px;">(b) Tax Exempted Income (Please see Instruction Page)
            </div>
            <div class="col-sm-2 br text-right pr-3"> <span>{{restructuredData?.sources_of_fund?.tax_exempted_income_and_allowances?.value |
                currencySeparatorBD}}</span></div>
            <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 30px;">(c) Receipt of Gift and Others</div>
            <div class="col-sm-2 br text-right pr-3"> <span>{{restructuredData?.sources_of_fund?.other_receipts?.value |
                currencySeparatorBD}}</span></div>
            <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 text-right br">Total Source of Fund:</div>
            <div class="col-sm-2 br"></div>
            <div class="col-sm-2 br text-right pr-3"><span>{{totalSourcesOfFund | currencySeparatorBD}}</span></div>
          </div>
        </div>
      </div>
      <div class="row bb bl">
        <div class="col-sm-8 br">2. Net Wealth as on Last Date of Previous Income Year</div>
        <div class="col-sm-2 br"></div>
            <div class="col-sm-2 br text-right pr-3">
              <span>{{restructuredData?.previous_net_wealth?.previous_income_year_net_wealth?.value |
                currencySeparatorBD}}
              </span>
            </div>
      </div>
      <div class="row bb bl">
        <div class="col-sm-8 br">3. Sum of Source of Fund and Previous Year’s Net Wealth (1 + 2)</div>
        <div class="col-sm-2 br"></div>
            <div class="col-sm-2 br text-right pr-3">
              <span>{{totalAssetsAndLastYearAssets | currencySeparatorBD}}</span>
            </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="row bb bl">
            <div class="col-sm-8 br">4.</div>
            <div class="col-sm-2 br">
            </div>
            <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 35px;">(a) Expense relating to Lifestyle (as per IT-10BB)</div>
            <div class="col-sm-2 br text-right pr-3"><span>{{annualLivingExpense | currencySeparatorBD}}</span>
            </div>
            <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 35px;">(b) Gift / Expenses / Loss Not Mentioned in IT-10BB</div>
            <div class="col-sm-2 br text-right pr-3"><span>{{lossAndGiftExpense | currencySeparatorBD}}</span>
            </div>
            <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 text-right br">Total Expense and Loss:</div>
            <div class="col-sm-2 br"></div>
            <div class="col-sm-2 br text-right pr-3"><span>{{totalLivingExpense | currencySeparatorBD}}</span></div>
          </div>
        </div>
      </div>
      <div class="row bb bl">
        <div class="col-sm-8 br">5. Net Wealth at the Last Date of this Financial Year (3 – 4)</div>
        <div class="col-sm-2 br"></div>
        <div class="col-sm-2 br text-right pr-3"><span>{{lastDateNetAssets | currencySeparatorBD}}</span></div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="row bb bl">
            <div class="col-sm-8 br">
              6. Personal Liabilities Outside Business
            </div>
            <div class="col-sm-2 br"> </div>
            <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 35px;">(a) Institutional Liabilities</div>
            <div class="col-sm-2 br text-right pr-3"><span>{{restructuredData?.liabilities?.borrowing_from_bank_or_other_fi?.value |
                currencySeparatorBD}}</span></div>
                <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 35px;">(b) Non-Institutional Liabilities</div>
            <div class="col-sm-2 br text-right pr-3"><span>{{restructuredData?.liabilities?.unsecured_loan?.value
                | currencySeparatorBD}}</span></div>
                <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 35px;">(c) Other Liabilities</div>
            <div class="col-sm-2 br text-right pr-3"><span>{{restructuredData?.liabilities?.other_loan_or_overdraft?.value |
                currencySeparatorBD}}</span></div>
                <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 text-right br">Total Liabilities Outside Business:</div>
            <div class="col-sm-2 br"></div>
            <div class="col-sm-2 br text-right pr-3">
              <span>
                {{liabilitiesOutsideBusiness | currencySeparatorBD}}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row bb bl">
        <div class="col-sm-8 br">7. Gross Wealth (5 + 6)</div>
        <div class="col-sm-2 br"></div>
        <div class="col-sm-2 br text-right pr-3">
          <span>
            {{ ( lastDateNetAssets + liabilitiesOutsideBusiness) | currencySeparatorBD}}
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="row bb bl">
            <div class="col-sm-8 br">
              8. Particulars of Assets (if needed attach separate sheet)
            </div>
            <div class="col-sm-2 br"> </div>
            <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 30px;">(a) Total Asset of Business</div>
            <div class="col-sm-2 br text-right pr-3"><span>{{totalBusinessAssets | currencySeparatorBD}}</span>
            </div>
            <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 30px;">Less: Business Liabilities (Institutional &
              Non-Institutional)</div>
            <div class="col-sm-2 br text-right pr-3"><span>{{businessLiabilities | currencySeparatorBD}}</span>
            </div>
            <div class="col-sm-2 br"> </div>
          </div>
          <!-- <div class="row bb bl bt">
            <div class="col-sm-8 br" style="padding-left: 30px;">ব্যবসার মূলধন (পরিসম্পদ ও দায়ের পার্থক্য)</div>
            <div class="col-sm-2 br"><span class="ml-3">{{(totalBusinessAssets - businessLiabilities) |
                currencySeparatorBD}}</span></div>
                <div class="col-sm-2 br"> </div>
          </div> -->
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 30px;">(b) Director’s Shareholdings in the Companies</div>
            <div class="col-sm-2 br text-right pr-3"><span>{{restructuredData?.assets?.business_capital?.director_shareholdings_in_limited_companies?.value
                | currencySeparatorBD}}</span></div>
                <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 30px;">(c) Business Capital of Partnership Firm</div>
            <div class="col-sm-2 br text-right pr-3"><span>{{restructuredData?.assets?.business_capital?.capital_of_partnership_firm?.value |
                currencySeparatorBD}}</span></div>
                <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 30px;">(d) Non-Agricultural Property / land / House Property
              (Acquisition / Cost Value with Legal Expense / Acquired Price / Building Cost / Investment)<br/>
              Location and Description of Non-Agricultural Property (use separate sheet if needed)
            </div>
            <div class="col-sm-2 br text-right pr-3"><span>{{totalNonAgriPropertyValue |
                currencySeparatorBD}}</span></div>
                <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 30px;">(e) Agricultural Property (Acquisition / Cost Value with
              Legal Expense)<br/>
              Location and Description of Agricultural Property (use separate sheet if needed)
            </div>
            <div class="col-sm-2 br text-right pr-3"><span>{{restructuredData?.assets?.agricultural_property?.value | currencySeparatorBD}}</span>
            </div>
            <div class="col-sm-2 br"> </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="row bb bl">
                <div class="col-sm-8 br" style="padding-left: 30px">
                  (f) Financial Assets:
                </div>
                <div class="col-sm-2 br"> </div>
                <div class="col-sm-2 br"> </div>
              </div>
              <div class="row bb bl">
                <div class="col-sm-8 br" style="padding-left: 60px;">(i) Share / Debenture / Bond / Securities / Unit
                  Certificate etc.</div>
                <div class="col-sm-2 br text-right pr-3"><span>{{restructuredData?.assets?.financial_assets?.share_debenture_etc?.value |
                    currencySeparatorBD}}</span></div>
                    <div class="col-sm-2 br"> </div>

              </div>
              <div class="row bb bl">
                <div class="col-sm-8 br" style="padding-left: 60px;">(ii) Sanchaypatra / Deposit Pension Scheme</div>
                <div class="col-sm-2 br text-right pr-3">
                  <span>
                    {{(restructuredData?.assets?.financial_assets?.savings_certificate_bonds_and_other_government_securities?.value
                    + restructuredData?.assets?.financial_assets?.dps?.value) | currencySeparatorBD}}
                  </span>
                </div>
                <div class="col-sm-2 br"> </div>
              </div>
              <div class="row bb bl">
                <div class="col-sm-8 br" style="padding-left: 60px;">(iii) Loan Given (Mention Name & NID of Loan Receiver)
                </div>
                <div class="col-sm-2 br text-right pr-3"><span>{{restructuredData?.assets?.financial_assets?.loans_given_to_others?.value |
                    currencySeparatorBD}}</span></div>
                    <div class="col-sm-2 br"> </div>
              </div>
              <div *ngIf="printActive" style="height: 80px"></div>
              <div class="row bb bl" [ngClass]="{'bt': printActive}">
                <div class="col-sm-8 br" style="padding-left: 60px;">(iv) Savings Deposit / Term Deposit</div>
                <div class="col-sm-2 br text-right pr-3"><span>{{restructuredData?.assets?.financial_assets?.fix_deposits_term_deposits_and_dps?.value
                    | currencySeparatorBD}}</span></div>
                    <div class="col-sm-2 br"> </div>
              </div>
              <div class="row bb bl">
                <div class="col-sm-8 br" style="padding-left: 60px;">(v) Provident Fund or Other Fund (if any)</div>
                <div class="col-sm-2 br text-right pr-3"><span>{{restructuredData?.assets?.financial_assets?.provident_fund_and_other_fund?.value |
                    currencySeparatorBD}}</span></div>
                    <div class="col-sm-2 br"> </div>
              </div>
              <div class="row bb bl">
                <div class="col-sm-8 br" style="padding-left: 60px;">(vi) Other Investment</div>
                <div class="col-sm-2 br text-right pr-3"><span>{{restructuredData?.assets?.financial_assets?.other_financial_assets?.value |
                    currencySeparatorBD}}</span></div>
                    <div class="col-sm-2 br"> </div>
              </div>
              <div class="row bb bl">
                <div class="col-sm-8 text-right br">Total Financial Assets:</div>
                <div class="col-sm-2 br text-right pr-3"><span>{{totalFinancialAssets |
                    currencySeparatorBD}}</span></div>
                    <div class="col-sm-2 br"> </div>
              </div>
            </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 30px;">(g) Motor Vehicle(s) (Cost Value including Registration
              Expense)</div>
            <div class="col-sm-2 br text-right pr-3"><span>{{restructuredData?.assets?.motor_car?.value |
                currencySeparatorBD}}</span></div>
                <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 30px">(Mention Type and Registration Number of Motor Vehicle)
            </div>
            <div class="col-sm-2 br"> </div>
            <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 30px;">(h) Ornaments (Mention Quantity) {{ornamentDetails}}</div>
            <div class="col-sm-2 br text-right pr-3"><span>{{restructuredData?.assets?.gold_diamond_gems_and_other_items?.value |
                currencySeparatorBD}}</span></div>
                <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 30px;">(i) Furniture and Electronic Items</div>
            <div class="col-sm-2 br text-right pr-3"><span>{{restructuredData?.assets?.furniture_equipments_and_electronic_items?.value |
                currencySeparatorBD}}</span></div>
                <div class="col-sm-2 br"> </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 br" style="padding-left: 30px;">(j) Other Assets (Except Assets Mentioned in Sl. k)</div>
            <div class="col-sm-2 br text-right pr-3"><span>{{restructuredData?.assets?.other_assets_of_significant_value?.value |
                currencySeparatorBD}}</span></div>
                <div class="col-sm-2 br"> </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="row bb bl">
                <div class="col-sm-8 br" style="padding-left: 30px">
                  (k) Cash in Hand and Fund Outside Business
                </div>
                <div class="col-sm-2 br"> </div>
                <div class="col-sm-2 br"> </div>

              </div>
              <div class="row bb bl">
                <div class="col-sm-8 br" style="padding-left: 60px;">(i) Bank Balance</div>
                <div class="col-sm-2 br text-right pr-3"><span>{{restructuredData?.assets?.cash_and_fund_outside_business?.notes_and_currencies?.value
                    | currencySeparatorBD}}</span></div>
                    <div class="col-sm-2 br"> </div>
              </div>
              <div class="row bb bl">
                <div class="col-sm-8 br" style="padding-left: 60px;">(ii) Cash in Hand</div>
                <div class="col-sm-2 br text-right pr-3"><span></span>{{restructuredData?.assets?.cash_and_fund_outside_business?.hand_cash?.value |
                  currencySeparatorBD}}</div>
                  <div class="col-sm-2 br"> </div>
              </div>
              <div class="row bb bl">
                <div class="col-sm-8 br" style="padding-left: 60px;">(iii) Others</div>
                <div class="col-sm-2 br text-right pr-3"><span>{{restructuredData?.assets?.cash_and_fund_outside_business?.other_deposits_balance_and_advance?.value
                    | currencySeparatorBD}}</span></div>
                    <div class="col-sm-2 br"> </div>
              </div>
              <!-- <div class="row">
                <div class="col-sm-8 text-right br">মোট আর্থিক সম্পদ</div>
                <div class="col-sm-2 br"><span class="ml-3">{{totalSavedCash | currencySeparatorBD}}</span>
                </div>
                <div class="col-sm-2 br"> </div>
              </div>
              <div class="row">
                <div class="col-sm-8 text-right br">বাংলাদেশে অবস্থিত মোট পরিসম্পদ</div>
                <div class="col-sm-2 br"><span class="ml-3">{{totalAssetsInsideBD |
                    currencySeparatorBD}}</span></div>
                    <div class="col-sm-2 br"> </div>
              </div> -->
              <div class="row bl bb">
                <div class="col-sm-8 text-right br">Total Cash in Hand and Fund Outside Business:</div>
                <div class="col-sm-2 br text-right pr-3"><span>{{totalSavedCash |
                    currencySeparatorBD}}</span></div>
                    <div class="col-sm-2 br"></div>
              </div>
            </div>
          </div>
          <div class="row bb bl">
            <div class="col-sm-8 text-right br">Total Assests inside Bangladesh</div>
            <div class="col-sm-2 br"></div>
            <div class="col-sm-2 br text-right pr-3"><span>{{totalAssetsInsideBD | currencySeparatorBD}}</span></div>
          </div>
        </div>
      </div>
      <div class="row bb bl">
        <div class="col-sm-8 br">9. Assets Outside Bangladesh</div>
        <div class="col-sm-2 br"></div>
          <div class="col-sm-2 br text-right pr-3">
            <span>{{restructuredData?.assets?.outside_property?.value |
              currencySeparatorBD}}</span>
          </div>
      </div>
      <div class="row bb bl">
        <div class="col-sm-8 br">10. Total Assets in Bangladesh and Outside Bangladesh (8 + 9)</div>
        <div class="col-sm-2 br"></div>
        <div class="col-sm-2 br text-right pr-3"><span>{{totalAssets | currencySeparatorBD}}</span></div>
      </div>
    </div>
  </div>
  <div *ngIf="!returnData?.profileData?.mandatoryITTenB" class="row mb-3 mt-3">
    <div class="col-sm-12 ml-4"><b><i>
      N.B. IT-10B is not mandatory and declared Gross Wealth only.</i></b>
    </div>
  </div>
  <div style="margin-top:80px" class="text-center">
    <u class="font-weight-bold">
      Verification
    </u>
  </div>
  <div class="row mb-5 mt-3">
    <div class="col-sm-12 ml-2">
      I solemnly declare that to the best of my knowledge and belief the information given in this IT-10B (2023) is
      correct and complete.
    </div>
  </div>
  <div class="row " style="margin-top:70px;">
    <div class="col-sm-6"></div>
    <div class="col-sm-6 text-center">
      <div>{{returnData?.profileData?.assesName}}</div>
      <div>
        Name & Signature of the Taxpayer
      </div>
      <div>
        Date: {{dateAfterSign}}
      </div>
      <div><strong><i>System generated document, it requires no signature</i></strong></div>
      <!-- <div class="pt-1 font-italic font-weight-bold">সিস্টেম জেনারেটেড ডকুমেন্ট। স্বাক্ষরের প্রয়োজন নেই।</div> -->
    </div>
  </div>
</div>
